import { render, staticRenderFns } from "./HaulageJobPage.vue?vue&type=template&id=2efa188a&scoped=true&"
import script from "./HaulageJobPage.vue?vue&type=script&lang=js&"
export * from "./HaulageJobPage.vue?vue&type=script&lang=js&"
import style0 from "./HaulageJobPage.vue?vue&type=style&index=0&id=2efa188a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa188a",
  null
  
)

export default component.exports